goog.provide('el8.ptdata.ptMaintItems');

goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.service.urls');


// see confidentialItems.js, ptAllergies.js

el8.ptdata.ptMaintItems = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.addDate('date', true);
    _class.addBoolean('abnormal', true);
    _class.addStringProperty('note', true);
    _class.addIntProperty('ruleId', true);
    _class.addIntProperty('physicianId', true);
    _class.addIntProperty('reportId', true);
    _class.addIntProperty('docTagId', true);

    _class.prototype.getPhysicianName = function() {
        if (!this.getPhysicianId()) { return null; }
        var physician = el8.data.physicians.getById(this.getPhysicianId());
        return physician ? physician.getFullName() : '';
    };

    //
    // Entity set
    //
    var that = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('ptMaintItems'); },
        saveFn: function(item, successCallbackFn) {
            var saved = false;
            $.el8_ajax({
                url: el8.service.urls.get('ptMaintItems', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.ptMaintItems.updateItemId(item, data.item.id);
                        el8.appservice.notifier.notify('Maintenance item updated');
                    } else {
                        el8.appservice.notifier.notify('Maintenance item saved');
                        saved = true;
                    }
                    item.populate(data.item);
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
            // Can only do this because async = false;
            return saved ? item : null;
        },
        deleteFn: function(item, successCallbackFn) {
            $.el8_ajax({
                url: el8.service.urls.get('ptMaintItems', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Maintenance item deleted');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });

    that.getByRuleId = function(ruleId) {
        return that.all().filter(function(item) { return item.getRuleId() === ruleId; });
    };

    return that;
})();


